import Loader from "react-loader-spinner";

function FullPageLoader() {
  return (
    <div
      className="text-center align-items-center"
      style={{ marginTop: "25%" }}
    >
      <Loader type="Oval" color="#1c743a" />
    </div>
  );
}

export default FullPageLoader;
